import { createAction, props } from "@ngrx/store";
import { IErrors } from "../../models/error";
import { IReportInfo, IResponse } from "../../models/admin";

enum ReportActions {
     // Fetch GST Orders
    FetchGSTOrders = '[Admin] Fetch GST Orders',
    FetchGSTOrdersSuccess = '[Admin] Fetch GST Orders Success',
    FetchGSTOrdersFailure = '[Admin] Fetch GST Orders Failure',
}

export const FetchGSTOrdersAction = createAction(
    ReportActions.FetchGSTOrders
);
export const FetchGSTOrdersSuccessAction = createAction(
    ReportActions.FetchGSTOrdersSuccess,
    props<{ response: IResponse<IReportInfo[]> }>()
);
export const FetchGSTOrdersFailureAction = createAction(
    ReportActions.FetchGSTOrdersFailure,
    props<{ error: IErrors }>()
);
